import { useCallback } from 'react'
import { useErrorModal } from '../../../hooks/api/use-error-modal'
import { useUpdateShipmentPositionMutation } from '../../../store/api/shipment-positions-api'
import { useUpdateAndCalculateShipmentMutation } from '../../../store/api/shipments-api'
import Shipment from '../../../types/api/shipment'
import ShipmentPosition from '../../../types/api/shipment-position'
import { ConvertRelationFields, EndpointQueryParameters } from '../../../types/strapi/strapi'
import { useUpdateQueryData } from './use-update-query-data'

export type ShipmentPositionUpdateData = Partial<ConvertRelationFields<ShipmentPosition>>

/** Сохранение позиции отгрузки и пересчёт самой отгрузки */
export function useUpdateShipmentPosition(queryArg: EndpointQueryParameters) {
    const [updateShipmentPosition, positionState] = useUpdateShipmentPositionMutation()
    const [updateAndCalculateShipment, recalculateState] = useUpdateAndCalculateShipmentMutation()
    const updateQueryData = useUpdateQueryData(queryArg)

    useErrorModal(positionState, 'Ошибка обновления позиции отгрузки')
    useErrorModal(recalculateState, 'Ошибка обновления отгрузки')

    return useCallback(
        async (record: Shipment, positionDocId: string, data: ShipmentPositionUpdateData) => {
            try {
                const res = await updateShipmentPosition({
                    docId: positionDocId,
                    body: { data },
                })

                if (res.data) {
                    const updatedPosition = res.data.data
                    // Сразу отражаем actualCopies/copies в строке отгрузки,
                    // даже если последующий пересчёт временно упадёт.
                    updateQueryData({
                        ...record,
                        shipment_positions: (record.shipment_positions ?? []).map(position =>
                            position.documentId === positionDocId
                                ? { ...position, ...updatedPosition }
                                : position
                        ),
                    })

                    // Пересчёт: план (calculated) + факт (calculatedOnActual при наличии расхода).
                    const recalculateRes = await updateAndCalculateShipment({
                        docId: record.documentId,
                        body: { data: {} },
                        queryParams: queryArg,
                    })

                    if (recalculateRes.data) {
                        updateQueryData(recalculateRes.data.data)
                    }
                }
            } catch {
                // ошибка обрабатывается хуком useErrorModal
            }
        },
        [updateShipmentPosition, updateAndCalculateShipment, queryArg, updateQueryData]
    )
}
